import TeamsList from 'teams/components/list/TeamsList'
import { PageLayout } from '@plm-core/utils'

const TeamsListPage = () => {
  return (
    <PageLayout>
      <TeamsList />
    </PageLayout>
  )
}

export default TeamsListPage
